import type { VoidFunctionComponent } from 'react';
import IssueDetailsDependencySection from '../DependencySection';

/**
 * QualityIssueDetailsDependency displays the dependency info
 * for the package which flagged this quality info.
 */
const QualityIssueDetailsDependency: VoidFunctionComponent = () => (
  <IssueDetailsDependencySection />
);

export default QualityIssueDetailsDependency;
